import type { AmlogicImageReport } from "../../core/amlogic/AmlogicImageParser";
import type { AmlogicDeviceSession } from "../../core/amlogic/multi/AmlogicDeviceSession";

export interface BatchPreflightTarget {
  session: AmlogicDeviceSession;
  eligible: boolean;
  reason?: string;
}

function isSessionReady(session: AmlogicDeviceSession): boolean {
  return session.status === "ready" || session.status === "completed";
}

function hasBl1BootstrapItems(report?: AmlogicImageReport): boolean {
  if (!report) return false;
  const usbItems = new Set(report.items.filter((item) => item.extension.toUpperCase() === "USB").map((item) => item.name.toUpperCase()));
  return (usbItems.has("DDR") && usbItems.has("UBOOT")) || (usbItems.has("DDR_ENC") && usbItems.has("UBOOT_ENC"));
}

export function preflightV3PackageTarget(session: AmlogicDeviceSession, report?: AmlogicImageReport): BatchPreflightTarget {
  if (session.generation !== "adnl-v3") return { session, eligible: false, reason: "Không phải thiết bị V3 ADNL" };
  if (!isSessionReady(session)) return { session, eligible: false, reason: `Trạng thái ${session.status}` };
  const info = session.service.handshakeInfo;
  if (!info) return { session, eligible: false, reason: "Chưa handshake ADNL" };
  if (info.stage === "BL1" && report && !hasBl1BootstrapItems(report)) {
    return { session, eligible: false, reason: "Package thiếu USB:DDR + USB:UBOOT phù hợp BL1" };
  }
  if (info.stage !== "UBOOT" && info.stage !== "BL1") {
    return { session, eligible: false, reason: `Stage ${info.stage} chưa hỗ trợ flash package` };
  }
  return { session, eligible: true };
}

export function preflightV3PartitionTarget(session: AmlogicDeviceSession): BatchPreflightTarget {
  if (session.generation !== "adnl-v3") return { session, eligible: false, reason: "Không phải thiết bị V3 ADNL" };
  if (!isSessionReady(session)) return { session, eligible: false, reason: `Trạng thái ${session.status}` };
  const info = session.service.handshakeInfo;
  if (!info) return { session, eligible: false, reason: "Chưa handshake ADNL" };
  if (info.stage !== "UBOOT") return { session, eligible: false, reason: `Cần UBOOT, hiện tại ${info.stage}` };
  return { session, eligible: true };
}

export function preflightV2Target(session: AmlogicDeviceSession): BatchPreflightTarget {
  if (session.generation !== "legacy-v2") return { session, eligible: false, reason: "Không phải thiết bị Legacy V2" };
  if (!isSessionReady(session)) return { session, eligible: false, reason: `Trạng thái ${session.status}` };
  if (session.usbDevice?.vendorId !== 0x1b8e || session.usbDevice.productId !== 0xc003) {
    return { session, eligible: false, reason: "Không còn ở WorldCup PID 0xC003" };
  }
  return { session, eligible: true };
}
